import React from 'react';
import type { FC, PropsWithChildren } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import type { HelmetProps } from 'react-helmet';
import { DEFAULT_SITE_TITLE } from '../../constants';

type Props = PropsWithChildren<{
    title?: string;
    description?: string;
    keywords?: string;
    noIndex?: boolean;
}> &
    HelmetProps;

const Seo: FC<Props> = ({ title, description, keywords, noIndex, children, ...props }) => {
    const fullTitle = title ? `${title} | ${DEFAULT_SITE_TITLE}` : DEFAULT_SITE_TITLE;

    return (
        <Helmet {...props}>
            <title>{fullTitle}</title>
            {description ? <meta name="description" content={description} /> : null}
            {keywords ? <meta name="keywords" content={keywords} /> : null}
            {noIndex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta name="robots" content="index, follow" />
            )}
            {children}
        </Helmet>
    );
};

Seo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    noIndex: PropTypes.bool,
    children: PropTypes.any,
};

Seo.defaultProps = {
    children: null,
    noIndex: false,
    title: undefined,
    description: undefined,
    keywords: undefined,
};

export default Seo;
